import { render, staticRenderFns } from "./Spin.vue?vue&type=template&id=3b908910&scoped=true&"
import script from "./Spin.vue?vue&type=script&lang=js&"
export * from "./Spin.vue?vue&type=script&lang=js&"
import style0 from "./Spin.vue?vue&type=style&index=0&id=3b908910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b908910",
  null
  
)

export default component.exports